import { useAuthStore } from '@/state/authStore';

export function AppHeader() {
  const user = useAuthStore((s) => s.currentUser);
  const clear = useAuthStore((s) => s.clear);

  const handleLogout = () => {
    clear();
    window.location.href = '/auth/logout';
  };

  const roleLabel = user?.is_admin
    ? '管理者'
    : user?.is_feedbacker
      ? 'フィードバッカー'
      : 'コーチ';

  return (
    <header className="flex h-14 items-center justify-between border-b border-gray-200 bg-white px-6">
      <h1 className="text-lg font-semibold text-gray-800">Delphi</h1>
      <div className="flex items-center gap-3">
        {user && (
          <>
            <span className="text-sm text-gray-700">
              {user.name}
              <span className="ml-2 rounded bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
                {roleLabel}
              </span>
            </span>
            <button
              type="button"
              onClick={handleLogout}
              className="rounded border border-gray-300 px-3 py-1 text-sm text-gray-700 hover:bg-gray-50"
            >
              ログアウト
            </button>
          </>
        )}
      </div>
    </header>
  );
}
